import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/Home/index'
import Category from '@/views/Home/category'
import UserCenter from '@/views/UserCenter/index'
import Search from '@/views/Search/index'
import Login from '@/views/Login/index'
import Register from '@/views/Register/index'
import QDirect from '@/views/Details/QDirect'
import BillDirect from '@/views/Details/BillDirect'
import FlowDirect from '@/views/Details/FlowDirect'
import Cami from '@/views/Details/Cami'
import personalData from '@/views/UserCenter/personalData'
import personalUpdata from '@/views/UserCenter/personalUpdata'
import feedBack from '@/views/UserCenter/feedBack'
import aboutUs from '@/views/UserCenter/aboutUs'
import forgetPassword from '@/views/UserCenter/forgetPassword'

import Order from '@/views/Order/index'
import orderList from '@/views/Order/orderList'
import orderInfo from '@/views/Order/orderInfo'

import Reallygood from '@/views/Details/Reallygood'
import Recharge from '@/views/Details/Recharge'
import selectAddress from '@/views/UserCenter/selectAddress'
import manageAddress from '@/views/UserCenter/manageAddress'
import addAddress from '@/views/UserCenter/addAddress'
import modifyPassword from '@/views/UserCenter/modifyPassword'
import goodsorderInfo from '@/views/Order/goodsorderInfo'

//yooojooo
import Lucky from '@/views/Ticket/lucky'
import LuckyPC from '@/views/Ticket/luckyPC'
import Ticket from '@/views/Ticket/ticket'
import useTicket from '@/views/Ticket/useTicket'

Vue.use(Router);
export default new Router({
//	mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/Category',
      name: 'Category',
      component: Category
    },
    {
      path: '/UserCenter',
      name: 'UserCenter',
      component: UserCenter,
      meta:{requireAuth:true}
    },
    {
      path: '/Search',
      name: 'Search',
      component: Search
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/QDirect',
      name: 'QDirect',
      component: QDirect
    },
    {
      path: '/BillDirect',
      name: 'BillDirect',
      component: BillDirect
    },
    {
      path: '/FlowDirect',
      name: 'FlowDirect',
      component: FlowDirect
    },
    {
      path: '/Recharge',
      name: 'Recharge',
      component: Recharge
    },
    {
      path: '/Cami',
      name: 'Cami',
      component: Cami
    },
    {
    	path: '/Reallygood',
    	name: 'Reallygood',
    	component: Reallygood
    },
    {
    	path: '/UserCenter/selectAddress',
    	name: 'selectAddress',
    	component: selectAddress
    },
    {
    	path: '/UserCenter/manageAddress',
    	name: 'manageAddress',
    	component: manageAddress
    },
    {
    	path: '/UserCenter/addAddress',
    	name: 'addAddress',
    	component: addAddress
    },
    {
      path: '/UserCenter/personalData',
      name: 'personalData',
      component: personalData,
      meta:{requireAuth:true}
    },
    {
      path: '/UserCenter/personalUpdata',
      name: 'personalUpdata',
      component: personalUpdata
    },
    {
      path: '/UserCenter/feedBack',
      name: 'feedBack',
      component: feedBack
    },
    {
      path: '/UserCenter/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/UserCenter/modifyPassword',
      name: 'modifyPassword',
      component: modifyPassword
    },
    {
      path: '/UserCenter/forgetPassword',
      name: 'forgetPassword',
      component: forgetPassword
    },
    {
      path: '/Order/index',
      name: 'Order',
      component: Order,
      meta:{requireAuth:true}
    },
    {
      path: '/Order/orderList',
      name: 'orderList',
      component: orderList,
      meta:{requireAuth:true}
    },
    {
      path: '/Order/orderInfo',
      name: 'orderInfo',
      component: orderInfo,
      meta:{requireAuth:true}
    },
    {
    	path: '/Order/goodsorderInfo',
    	name: 'goodsorderInfo',
    	component: goodsorderInfo,
    	meta:{requireAuth:true}
    },
    {
    	path: '/Ticket/Lucky',
    	name: 'lucky',
    	component: Lucky,
    },
    {
    	path: '/Ticket/LuckyPC',
    	name: 'luckyPC',
    	component: LuckyPC,
    },
    {
    	path: '/Ticket/ticket',
    	name: 'ticket',
    	component: Ticket,
    },
     {
    	path: '/Ticket/useTicket',
    	name: 'useTicket',
    	component: useTicket,
    	meta:{requireAuth:true}
    },
    {
    	path: '*',
    	redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js